import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-permission',
  templateUrl: './user-permission.component.html',
  styleUrls: ['./user-permission.component.scss','./user-permission.component.rtl.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class UserPermissionComponent implements OnInit {
  @Input() permissionName: any
 constructor(
    public translate: TranslateService,
  ) { }
  ngOnInit(): void {
    console.log(this.permissionName)
  }

}
